export const GAMESESSIONLOG_LIST_REQUEST = 'GAMESESSIONLOG_LIST_REQUEST';

export const GAMESESSIONLOG_LIST = 'GAMESESSIONLOG_LIST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_GAMESESSIONLOG_PAGINATION = 'SET_GAMESESSIONLOG_PAGINATION';

export const GAMESESSIONLOG_PAGE_RESET = 'GAMESESSIONLOG_PAGE_RESET';
